import { render, staticRenderFns } from "./ConfirmCopyDocument.vue?vue&type=template&id=96dd00ee&"
import script from "./ConfirmCopyDocument.vue?vue&type=script&lang=js&"
export * from "./ConfirmCopyDocument.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCopyDocument.vue?vue&type=style&index=0&id=96dd00ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports